export default __webpack_public_path__ + "static/media/ruby_on_rails.7bf611a6.svg";